import { render, staticRenderFns } from "./PassiveIncome.vue?vue&type=template&id=034e188f&"
import script from "./PassiveIncome.vue?vue&type=script&lang=js&"
export * from "./PassiveIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports